import {
  BreadcrumbJsonLd,
  FAQPageJsonLd,
  NextSeo,
  ProductJsonLd,
} from 'next-seo';
import Head from 'next/head';
import { images } from '../../../Constants/ImageUrls';
import {
  inStockSchema,
  metaDescriptionAppendString,
  outOfStockSchema,
  pdpDefaultMetaDescription,
  pdpDefaultMetaTitle,
} from '../../../Constants/PdpContants';
import {
  BrandName,
  hardCodeCanonicalUrls,
} from '../../../Constants/ProductPage';
import { getSeoVisibility } from '../../../appconfig';
import { getBreadCrumbsJSONldData } from '../../../datafetchers/CategoryPage';
import { generateTimeString, getWebUserId } from '../../../Utils/helper';
import { useEffect } from 'react';
import {
  
  diaperPdpIds,
} from '../FertilityTrustSection/constant';

export default function index(props) {
  const {
    productData,
    DiscussionJSONLDData,
    ReviewJSONLDData,
    userType,
    breadCrumbsData,
    fromOriginalPdp,
    offerData,
  } = props;
  let FAQPage = [];
  let imagesArray = [];
  let reviews = [];

  DiscussionJSONLDData?.map((element) => {
    if (element?.questionName && element?.acceptedAnswerText) {
      FAQPage.push({
        questionName: element?.questionName,
        acceptedAnswerText: element?.acceptedAnswerText,
      });
    }
  });
  productData.review_count
    ? ReviewJSONLDData?.map((item) => {
        reviews.push({
          author: item?.username,
          reviewBody: item?.title,
          reviewRating: item?.reviewRating,
          positiveNotes:
            item?.reviewRating?.ratingValue > 3
              ? item?.positiveNotes
              : item?.negativeNotes,
        });
      })
    : '';
  productData?.images?.map((element) => {
    imagesArray.push(element);
  });
  const aggregateRating = {
    ratingValue: productData.avg_rating,
    reviewCount: productData.review_count,
  };
  const productName = productData?.name;
  const productWebUrl = productData?.web_url;
  const productFirstImage = productData?.images?.[0];
  const metaTitle = productData?.meta_title || pdpDefaultMetaTitle(productName);
  const metaDescription = productData?.meta_description
    ? productData?.meta_description?.trimEnd() + metaDescriptionAppendString
    : pdpDefaultMetaDescription(productName);

  const getCanonicalUrl = () => {
    const productId = productData?.id;
   
    
    // return (
    //   hardCodeCanonicalUrls[productId] ||
    //   `https://mylofamily.com${productWebUrl}`
    // );

    let canonical =
      hardCodeCanonicalUrls[productId] ||
      `https://mylofamily.com${productWebUrl}`;
     
      const isDiaperPdp = diaperPdpIds.includes(productData?.variant_id);
      if( isDiaperPdp )
           canonical='https://mylofamily.com/product/baby-diaper-pants-small-s-size-4-8-kgs-42-count-leak-proof-lightweight-rash-free-12-hours-protection-2378'

    // Remove query parameters
    if (canonical.includes('?')) {
      canonical = canonical.split('?')[0];
    }
   

    return canonical;
  };
  const { day, year, monthNo } = generateTimeString(
    offerData?.[0]?.expire_date,
  );
  const expiryDate = `${year}-${monthNo}-${day}`;

  useEffect(() => {
    const event = new CustomEvent('page_view_kp', {
      detail: {
        type: 'product',
        data: {
          cart_id: getWebUserId(),
          product_id: productData?.id,
          variant_id: productData?.variant_id,
          image_url: productData?.images?.[0],
          name: productData?.name,
          price: productData.price,
          handle: `https://mylofamily.com${productWebUrl}`,
        },
      },
    });
    window.dispatchEvent(event);
  }, [productData]);

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={{
              title: metaTitle,
              description: metaDescription,
              type: 'product',
              url: `https://mylofamily.com${productWebUrl}`,
              images: [
                {
                  url: productFirstImage,
                  width: 800,
                  height: 800,
                },
              ],
            }}
            noindex={
              fromOriginalPdp &&
              (productData?.id == '3483' ||
                productData?.id == '4088' ||
                productData?.id == '4089' ||
                productData?.id == '4090' ||
                productData?.id == '4091')
                ? true
                : false
            }
            nofollow={
              fromOriginalPdp &&
              (productData?.id == '3483' ||
                productData?.id == '4088' ||
                productData?.id == '4089' ||
                productData?.id == '4090' ||
                productData?.id == '4091')
                ? true
                : false
            }
          />
          <ProductJsonLd
            productName={productName}
            images={imagesArray}
            description={productName}
            brand={BrandName}
            manufacturerName={BrandName}
            manufacturerLogo={images.logo}
            reviews={reviews}
            offers={{
              url: 'https://mylofamily.com' + productData?.web_url,
              price: offerData?.[0]?.offerPrice,
              priceCurrency: 'INR',
              priceValidUntil: expiryDate,
              itemCondition: 'NewCondition',
              discountCode: offerData?.[0]?.code,
              availability:
                productData?.status == '4' ? outOfStockSchema : inStockSchema,
            }}
            aggregateRating={productData.review_count ? aggregateRating : ''}
            sku={productData?.id}
          />
        </>
      ) : null}
      {FAQPage?.length > 0 && <FAQPageJsonLd mainEntity={FAQPage} />}
      <Head>
        <link rel="preload" href={images.defaultImage} as="image" />
        <meta name="google" content="notranslate" />
        <meta property="og:title" content={productData?.name} />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content={`https://mylofamily.com/${productData?.web_url}`}
        />
        <meta property="og:image" content={productData?.images?.[0]} />
        <meta property="og:description" content={productData?.description} />
        <meta property="og:site_name" content="Mylo" />
        <meta property="og:locale" content="en_US" />
        <script
          key="organizationLD"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org",
                            "@graph": [{
                              "@type": "Organization",
                              "@id": "https://mylofamily.com/#organization",
                              "name": "",
                              "url": "https://mylofamily.com/",
                              "sameAs": []
                            }, {
                              "@type": "WebSite",
                              "@id": "https://mylofamily.com/#website",
                              "url": "https://mylofamily.com/",
                              "name": "${BrandName}",
                              "publisher": {
                                "@id": "https://mylofamily.com/#organization"
                              }
                            }, {
                              "@type": "WebPage",
                              "@id": "https://mylofamily.com${productWebUrl}#webpage",
                              "url": "https://mylofamily.com${productWebUrl}",
                              "inLanguage": "en",
                              "name": "${productName}",
                              "isPartOf": {
                                "@id": "https://mylofamily.com/#website"
                              },
                              "about": {
                                "@id": "https://mylofamily.com/#organization"
                              },
                              "datePublished": "2018-10-03T12:46:10+00:00",
                                "dateModified": "2021-09-22T04:46:06+00:00",
                              "description": "${productName}"
                              
                            ,"image": {
                                "@type": "ImageObject",
                                "@id": "#primaryimage",
                                "url": "${productFirstImage}",
                                "width": 800,
                                "height": 800,
                                "caption": ""
                              },
                              "primaryImageOfPage": {
                                "@id": "#primaryimage"
                              }
                            
                            }]}`,
          }}
        ></script>

        {!productWebUrl.startsWith('services') && (
          <link key="canonical" rel="canonical" href={getCanonicalUrl()} />
        )}
      </Head>
      {breadCrumbsData?.length > 0 && (
        <BreadcrumbJsonLd
          itemListElements={getBreadCrumbsJSONldData(breadCrumbsData)}
        />
      )}
    </>
  );
}
